'use strict';
var _ = require('underscore');

function localError(e, suppress) {
}

function localOnError(msg) {
  console.error(msg);
}

var logURL = window.en ? 'http://log.mockplus.cn/js/en' : 'http://log.mockplus.cn/js/cn';

exports.error = window.mockplus ? function (err) {
  // if (_.isString(err) && err.indexOf('Warning') === 0) { // ignore react warning
  //   return;
  // }
  // if (_.isString(err)) {
  //   return $.ajax({
  //     type: "POST",
  //     url: logURL,
  //     data: JSON.stringify({
  //       message: err,
  //       stack: '',
  //       error: ''
  //     }),
  //     success: function () {
  //
  //     },
  //     dataType: "json"
  //   });
  // }
  // $.ajax({
  //   type: "POST",
  //   url: logURL,
  //   data: JSON.stringify({
  //     message: err.message,
  //     stack: err.stack,
  //     error: err
  //   }),
  //   success: function () {
  //
  //   },
  //   dataType: "json"
  // });
} : localError;

exports.onerror = window.mockplus ? function (msg, url, lineNo, columnNo, error) {
  // $.ajax({
  //   type: "POST",
  //   url: logURL,
  //   data: JSON.stringify({
  //     file: url,
  //     message: msg,
  //     stack: '',
  //     line_no: lineNo,
  //     column_no: columnNo,
  //     error: JSON.stringify(error)
  //   }),
  //   success: function () {
  //
  //   },
  //   dataType: "json"
  // });
} : localOnError;


// WEBPACK FOOTER //
// ./src/helper/logHelper.js